import { render, staticRenderFns } from "./footerWidgets.vue?vue&type=template&id=ebd7b112&scoped=true&"
import script from "./footerWidgets.vue?vue&type=script&lang=js&"
export * from "./footerWidgets.vue?vue&type=script&lang=js&"
import style0 from "./footerWidgets.vue?vue&type=style&index=0&id=ebd7b112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd7b112",
  null
  
)

export default component.exports